import { render, staticRenderFns } from "./FontAwesomeRadio.vue?vue&type=template&id=2d8fc4ba"
import script from "./FontAwesomeRadio.vue?vue&type=script&lang=js"
export * from "./FontAwesomeRadio.vue?vue&type=script&lang=js"
import style0 from "./FontAwesomeRadio.vue?vue&type=style&index=0&id=2d8fc4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports